<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <el-input-number
        v-model="inner"
        :min="hasLimit ? cfgData.numberStart : -Infinity"
        :max="hasLimit ? cfgData.numberEnd : Infinity"
        :placeholder="field.prompt || ''"
        controls-position="right"
        style="width:100%"
        @change="$emit('input', inner)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldNumber',
  props: { field: Object, value: { default: undefined } },
  data () { return { inner: this.value !== '' && this.value !== undefined ? Number(this.value) : undefined } },
  watch: { value (v) { this.inner = v !== '' && v !== undefined ? Number(v) : undefined } },
  computed: {
    cfgData () { return this.field.data || {} },
    hasLimit () { return this.cfgData.numberLimit === 1 }
  }
}
</script>
